import { makeAutoObservable } from 'mobx'
import { type IResponseBalance, type IResponseReferralsHistory } from '../api'

export type IReferralsHistory = Referrals

export class Referrals {
  private _current_balance: IResponseBalance | null = null
  private _earnings: IResponseBalance | null = null
  private _earnings_balance = 0
  private _facebook_link: string | null = null
  private _leads_count = 0
  private _linkedin_link: string | null = null
  private _paid_balance: IResponseBalance | null = null
  private _paypal_email: string | null = null
  private _referral_link: string | null = null
  private _reward_amount = 0
  private _twitter_link: string | null = null
  private _visitors_count = 0

  constructor(private _origin: IResponseReferralsHistory) {
    makeAutoObservable(this)
    this.syncOrigin(_origin)
  }

  get earningsBalance() {
    return this._earnings_balance
  }

  get facebookLink() {
    return this._facebook_link
  }

  get leadsCount() {
    return this._leads_count
  }

  get linkedinLink() {
    return this._linkedin_link
  }

  get referralLink() {
    return this._referral_link
  }

  get rewardAmount() {
    return this._reward_amount
  }

  get twitterLink() {
    return this._twitter_link
  }

  get visitorsCount() {
    return this._visitors_count
  }

  get paidBalance() {
    return this._paid_balance
  }

  get earnings() {
    return this._earnings
  }

  get paypalEmail() {
    return this._paypal_email
  }

  syncOrigin(origin: IResponseReferralsHistory) {
    this._current_balance = origin.current_balance
    this._earnings = origin.earnings
    this._earnings_balance = origin.earnings_balance
    this._facebook_link = origin.facebook_link
    this._leads_count = origin.leads_count
    this._linkedin_link = origin.linkedin_link
    this._paid_balance = origin.paid_balance
    this._paypal_email = origin.paypal_email
    this._referral_link = origin.referral_link
    this._reward_amount = origin.reward_amount
    this._twitter_link = origin.twitter_link
    this._visitors_count = origin.visitors_count
  }
}
